import type { ReactNode } from 'react';

interface PageTemplateProps {
  header?: ReactNode;
  children: ReactNode;
}

/**
 * Standalone page shell — header strip + content column. Pair with
 * `<PageHeader />` from this directory.
 *
 * Not generated from the `@eds/page-template` registry: the EDS block
 * wraps its content in `<SidebarProvider>` + `<Sidebar>` + `<SidebarInset>`,
 * but spec D9 explicitly drops the sidebar (rebuild ships header + content
 * only). Adopting the EDS block would pull `evo-sidebar` + `sidebar` +
 * `card` registries we don't render and add ~30 KB of unused chrome to the
 * library bundle. Revisit if a sidebar lands in a future phase.
 */
export function PageTemplate({ header, children }: PageTemplateProps) {
  return (
    <div className="flex h-full flex-col">
      <div className="container mx-auto flex min-h-0 flex-1 flex-col space-y-6 px-6 py-8 rotaready:w-full rotaready:max-w-full rotaready:space-y-3 rotaready:m-0 rotaready:p-0">
        {header}
        <main className="flex min-h-0 flex-1 flex-col overflow-auto">{children}</main>
      </div>
    </div>
  );
}
